module.exports = __webpack_public_path__ + "static/media/about-tri.d4c97782.svg";